/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellPlanningPriorityCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
  };
}

const CellPlanningPriorityCellComponent =
  templateOnlyComponent<CellPlanningPriorityCellSignature>();

export default CellPlanningPriorityCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::PlanningPriorityCell': typeof CellPlanningPriorityCellComponent;
    'cell/planning-priority-cell': typeof CellPlanningPriorityCellComponent;
  }
}
